import React, {
  forwardRef,
  useRef,
  useImperativeHandle,
  useContext,
  useState,
  useEffect,
} from 'react';
import {
  Box,
  Button,
  TextField,
  Typography,
  FormControl,
} from '@material-ui/core';
import { useForm, Controller } from 'react-hook-form';
import AddIcon from '@material-ui/icons/Add';
import ColorLensIcon from '@material-ui/icons/ColorLens';
import CloseIcon from '@material-ui/icons/Close';
import DoneIcon from '@material-ui/icons/Done';
import { SketchPicker } from 'react-color';
import { useDispatch } from 'dva';
import TitleML from '../TitleML/TitleML';
import { StepsTwoMLStyled, ModalStyled } from './StepsTwoMLStyles';
import { Context } from '../../AddActivity';
import PrizesListForm from '../PrizesListForm';
import { TextFieldCom, CheckBoxFieldCom, SelectFieldCom } from '../FormType';
import ModalML from '@/components/ModalML';

const baseSettingList = [
  {
    key: 'defaultNum',
    leftName: '默认抽奖',
    rightName: '次',
    label: '默认抽奖次数',
    isParseInt: true,
    required: true,
  },
  {
    key: 'dailyDrawNum',
    leftName: '每人每天有',
    rightName: '次',
    label: '每日抽奖机会',
    isParseInt: true,
  },
  {
    key: 'winNum',
    leftName: '最多可中奖',
    rightName: '次',
    label: '每人中奖次数',
    isParseInt: true,
  },
];
const detailedSettingList = [
  {
    checkKey: 'isPurchase',
    leftName: '单笔购买',
    leftKey: 'purchase',
    mName: '元商品可抽奖',
    mKey: 'purchaseDrawNum',
    rightName: '次',
    isParseIntRight: true,
    isParseIntLeft: false,
  },
  {
    checkKey: 'isPoint',
    leftName: '消耗',
    leftKey: 'pointNum',
    mName: '积分可获得',
    mKey: 'pointDrawNum',
    rightName: '次抽奖',
    isParseIntRight: true,
    isParseIntLeft: false,
  },
  {
    checkKey: 'isShare',
    leftName: '分享',
    leftKey: 'shareNum',
    mName: '次活动可获得',
    mKey: 'shareDrawNum',
    rightName: '次抽奖',
    isParseIntRight: true,
    isParseIntLeft: true,
  },
];
const fontSizeList = [
  { name: '12', value: 12 },
  { name: '14', value: 14 },
  { name: '16', value: 16 },
  { name: '18', value: 18 },
  { name: '20', value: 20 },
];

const chooseResetPrize = (data) => {
  let status = 0;
  let num = 0;
  data.forEach((item) => {
    if (item.isLastPrize) {
      status = 1;
      ++num;
    }
  });
  if (num > 1) {
    status = 2;
  }
  return status;
};

export default forwardRef(
  (
    {
      onSubmitSuccess,
      prizesObj,
      defaultValues,
      formIds,
      setFormIds,
      setCheckFormIds,
      checkFormIds,
      giftList,
      giftTotal,
      queryType,
      queryLevelsList,
      pageId,
    },
    fRef,
  ) => {
    const { handleSubmit, control, errors, setValue, getValues, clearErrors } =
      useForm();
    const { ref } = useContext(Context);
    const [openColorModal, setOpenColorModal] = useState(false);
    const [inputName, setInputName] = useState();
    const [color, setColor] = useState('');
    const [changeNum, setChangeNum] = useState(0);
    const [prizesList, setPrizesList] = useState([prizesObj()]);
    const dispatch = useDispatch();
    const submitRef = useRef(null);
    const clickInputRef = () => {
      submitRef.current.click();
    };
    useImperativeHandle(ref, () => ({
      // handleSubmit 就是暴露给父组件的方法
      clickInput: clickInputRef,
    }));
    //添加卡片
    const handleAddPrizes = () => {
      if (formIds.length !== prizesList.length) {
        return;
      }
      const newObj = prizesObj();
      const prizesListForm = getValues('prizesList');
      const list = [...queryLevelsList];
      newObj.probability = list;
      setValue('prizesList', [...prizesListForm, newObj]);
      setPrizesList([...prizesListForm, newObj]);
    };
    //删除卡片
    const handleDelete = (id) => {
      const prizesListForm = [...prizesList];
      const list = prizesListForm.filter((item) => {
        return id !== item.id;
      });
      setValue('prizesList', list);
      setPrizesList(list);
    };
    //出现保存按钮
    const resetPrize = (id, key, value, pId) => {
      let uid = pId ? pId : id;
      const newCheckFormIds = checkFormIds.filter((item) => item !== uid);
      setCheckFormIds(newCheckFormIds);
      const ids = formIds.filter((item) => item !== uid);
      setFormIds(ids);
    };

    useEffect(() => {
      if (!pageId) {
        const pList = prizesList[0];
        pList.probability = queryLevelsList;
        setPrizesList([pList]);
        setValue('prizesList', [pList]);
      } else {
        const prizesListDetail = defaultValues.prizesList;
        prizesListDetail.forEach((item) => {
          console.log(1111111, item);
          item.chooseIds = item.prizeGoods
            ? [{ id: Number(item.prizeGoods) }]
            : [];

          item.probability.forEach((i) => {
            const itemD = queryLevelsList.filter((x) => x.level === i.level);
            i.name = itemD[0].name;
          });
        });
        setPrizesList(prizesListDetail);
        setValue('prizesList', prizesListDetail);
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [queryLevelsList]);
    useEffect(() => {
      for (let key in defaultValues) {
        if (key !== 'prizesList') {
          setValue(key, defaultValues[key]);
        }
      }
    }, [defaultValues, setValue]);

    const resetStyle = (key1, key2) => {
      setChangeNum(changeNum + 1);
      setValue(key1, 14);
      setValue(key2, '#000000');
    };
    const checkForm = (id, type) => {
      if (type === 'add') {
        formIds.push(id);
        clearErrors('prizesList');
        setFormIds(formIds);
        setChangeNum(changeNum + 1);
        checkFormIds.push(id);
        setCheckFormIds(checkFormIds);
      } else {
        const ids = formIds.filter((item) => item !== id);
        setFormIds(ids);
        const newCheckFormIds = checkFormIds.filter((item) => item !== id);
        setCheckFormIds(newCheckFormIds);
      }
    };
    //可用门店搜索
    const getGiftQueryPage = ({
      title,
      pageNum,
      pageSize,
      category,
      groupNo,
      type,
      // id,
    }) => {
      dispatch({
        type: 'addActivity/getGiftQueryPage',
        payload: {
          value: {
            title,
            pageNum,
            pageSize,
            category,
            groupNo,
            type,
            status: 'ON',
          },
        },
        callBack: () => {
          // const obj = {title, pageNum, pageSize, category, groupNo};
          // for (let v in obj) {
          //   resetPrize(id, v, obj[v]);
          // }
          // updateFormFun({ formData: obj, id, noSave: true });
        },
      });
    };

    const updateFormFun = ({ formData, id, isCheckForm }) => {
      const oldPrizesList = [...prizesList];
      let objKeys = Object.keys(formData);
      oldPrizesList.forEach((item) => {
        if (item.id === id) {
          objKeys.indexOf('isLastPrize') > -1 &&
            (item.isLastPrize = formData.isLastPrize);
          objKeys.indexOf('picUrl') > -1 && (item.picUrl = formData.picUrl);
          objKeys.indexOf('prizeAmount') > -1 &&
            (item.prizeAmount = formData.prizeAmount);
          objKeys.indexOf('prizeDescription') > -1 &&
            (item.prizeDescription = formData.prizeDescription);
          objKeys.indexOf('prizeLevel') > -1 &&
            (item.prizeLevel = formData.prizeLevel);
          objKeys.indexOf('prizeNum') > -1 &&
            (item.prizeNum = formData.prizeNum);
          objKeys.indexOf('prizeTitle') > -1 &&
            (item.prizeTitle = formData.prizeTitle);
          objKeys.indexOf('prizeType') > -1 &&
            (item.prizeType = formData.prizeType);
          objKeys.indexOf('sendType') > -1 &&
            (item.sendType = formData.sendType);
          objKeys.indexOf('category') > -1 &&
            (item.category = formData.category);
          objKeys.indexOf('type') > -1 && (item.type = formData.type);
          objKeys.indexOf('title') > -1 && (item.title = formData.title);
          objKeys.indexOf('pageNum') > -1 && (item.pageNum = formData.pageNum);
          objKeys.indexOf('pageSize') > -1 &&
            (item.pageSize = formData.pageSize);
          objKeys.indexOf('chooseIds') > -1 &&
            (item.chooseIds = formData.chooseIds);
          objKeys.indexOf('picUrlImgs') > -1 &&
            (item.picUrlImgs = formData.picUrlImgs);
          if (objKeys.indexOf('level1') > -1) {
            item.probability.forEach((it, index) => {
              if (it.level === index + 1) {
                const key = 'level' + it.level;
                it.probability = formData[key];
              }
            });
          }
        }
      });
      setValue('prizesList', oldPrizesList);
      setPrizesList(oldPrizesList);
      !isCheckForm && checkForm(id, 'add');
    };
    let prizesListError =
      !getValues('prizesList') || getValues('prizesList').length === 0
        ? '请设置奖项组设定并保存'
        : chooseResetPrize(prizesList) === 0
        ? '请勾选默认奖品'
        : chooseResetPrize(prizesList) === 2
        ? '选默认奖品只能勾选一项'
        : '';
    return (
      <StepsTwoMLStyled>
        <Box className="step-one-wrap" ref={fRef} mr={22}>
          <TitleML
            title="奖项组设定"
            fontSize="19px"
            p="32px 0"
            subtitleTitle={errors.prizesList ? prizesListError : ''}
            isError={true}
          />
          <Box>
            {prizesList.map((item, index) => {
              return (
                <PrizesListForm
                  data={item}
                  key={index}
                  id={item.id}
                  handleDelete={handleDelete}
                  resetPrize={resetPrize}
                  probabilityList={item.probability || []}
                  checkForm={checkForm}
                  formIds={formIds}
                  checkFormIds={checkFormIds}
                  giftList={giftList}
                  getGiftQueryPage={getGiftQueryPage}
                  total={giftTotal}
                  queryType={queryType}
                  updateFormFun={updateFormFun}
                  prizesList={prizesList}
                />
              );
            })}
            {queryType !== 'detail' && (
              <Box mt={1.5} display="flex" alignItems="flex-end" gap="0 16px">
                <Button
                  variant="contained"
                  startIcon={<AddIcon />}
                  sx={{ width: '118px', borderRadius: '24px', height: '34px' }}
                  onClick={handleAddPrizes}
                >
                  点击添加
                </Button>
                {formIds.length !== prizesList.length && (
                  <span
                    style={{
                      fontSize: '12px',
                      color: '#999',
                      fontWeight: '500',
                      lineHeight: '1',
                    }}
                  >
                    请保存所有的奖项组设定后再点击添加
                  </span>
                )}
              </Box>
            )}
          </Box>
          <form onSubmit={handleSubmit(onSubmitSuccess)}>
            <TitleML
              title="基本设定"
              subtitleTitle="不填即表示不限制"
              fontSize="19px"
              p="32px 0"
            />
            <Box display="flex" gap="0 65px">
              {baseSettingList.length > 0 &&
                baseSettingList.map((item, index) => {
                  return (
                    <Box key={index}>
                      <Box
                        sx={{
                          fontSize: 12,
                          color: '#212100',
                          marginBottom: '8px',
                        }}
                      >
                        {item.label}
                      </Box>
                      <Box
                        key={index}
                        display="flex"
                        justifyContent="space-between"
                        className="probability-list-wrap"
                      >
                        <Box
                          fontSize="16px"
                          fontWeight="400"
                          color="#404041"
                          marginRight="4px"
                        >
                          {item.leftName}
                        </Box>
                        <Box width="80px">
                          <Controller
                            render={(pr) => (
                              <TextFieldCom
                                pr={pr}
                                id={item.key}
                                errors={errors}
                                label=""
                                queryType={queryType}
                                isPositiveNumber={true}
                                isNumber={true}
                                isParseInt={item.isParseInt}
                                setValue={setValue}
                              />
                            )}
                            control={control}
                            name={item.key}
                            rules={{
                              required: item?.required,
                            }}
                          />
                        </Box>
                        <Box
                          ml={0.5}
                          fontSize="14px"
                          fontWeight="400"
                          color="#404041"
                        >
                          {item.rightName}
                        </Box>
                      </Box>
                    </Box>
                  );
                })}
            </Box>
            <TitleML
              title="详细设定"
              subtitleTitle="满足以上设置条件抽奖次数自动发放，每日零点可获得新的抽奖机会"
              fontSize="19px"
              p="32px 0"
            />
            <Box>
              {detailedSettingList.map((item, index) => {
                return (
                  <Box
                    key={index}
                    display="flex"
                    alignItems="center"
                    className="probability-list-wrap"
                  >
                    <Box className="checkbox-radio-disabled-color checkBox-no-label">
                      <Controller
                        render={(pr) => (
                          <CheckBoxFieldCom
                            pr={pr}
                            label=""
                            queryType={queryType}
                            onCallBack={() => {
                              if (getValues(item.checkKey)) {
                                setValue(item.leftKey, '');
                                setValue(item.mKey, '');
                              }
                            }}
                          />
                        )}
                        control={control}
                        name={item.checkKey}
                      />
                    </Box>
                    <Box
                      fontSize="16px"
                      fontWeight="400"
                      color="#404041"
                      marginRight="4px"
                    >
                      {item.leftName}
                    </Box>
                    <Box width="80px">
                      <Controller
                        render={(pr) => (
                          <TextFieldCom
                            pr={pr}
                            id={item.leftKey}
                            errors={errors}
                            label=""
                            queryType={queryType}
                            isPositiveNumber={true}
                            isNumber={true}
                            setValue={setValue}
                            errorText="必填项"
                            isParseInt={item.isParseIntLeft}
                          />
                        )}
                        control={control}
                        name={item.leftKey}
                        rules={{
                          validate: () => {
                            if (
                              getValues(item.checkKey) &&
                              (getValues(item.leftKey) <= 0 ||
                                !getValues(item.leftKey))
                            ) {
                              return false;
                            }
                            return true;
                          },
                        }}
                      />
                    </Box>
                    <Box
                      fontSize="16px"
                      fontWeight="400"
                      color="#404041"
                      marginRight="4px"
                    >
                      {item.mName}
                    </Box>
                    <Box width="80px">
                      <Controller
                        render={(pr) => (
                          <TextFieldCom
                            pr={pr}
                            id={item.mKey}
                            errors={errors}
                            label=""
                            queryType={queryType}
                            isPositiveNumber={true}
                            isNumber={true}
                            setValue={setValue}
                            errorText="必填项"
                            isParseInt={item.isParseIntRight}
                          />
                        )}
                        control={control}
                        name={item.mKey}
                        rules={{
                          validate: () => {
                            if (
                              getValues(item.checkKey) &&
                              (getValues(item.mKey) <= 0 ||
                                !getValues(item.mKey))
                            ) {
                              return false;
                            }
                            return true;
                          },
                        }}
                      />
                    </Box>
                    <Box
                      ml={0.5}
                      fontSize="14px"
                      fontWeight="400"
                      color="#404041"
                    >
                      {item.rightName}
                    </Box>
                  </Box>
                );
              })}
              <Box
                display="flex"
                alignItems="center"
                className="probability-list-wrap"
              >
                <Box className="checkbox-radio-disabled-color checkBox-no-label">
                  <Controller
                    render={(pr) => (
                      <CheckBoxFieldCom
                        pr={pr}
                        label=""
                        queryType={queryType}
                        onCallBack={() => {
                          if (getValues('isShareMember')) {
                            setValue('memberDrawNum', '');
                          }
                        }}
                      />
                    )}
                    control={control}
                    name="isShareMember"
                  />
                </Box>
                <Box
                  fontSize="16px"
                  fontWeight="400"
                  color="#404041"
                  marginRight="4px"
                >
                  分享后需注册为会员才能获得额外
                </Box>
                <Box width="80px">
                  <Controller
                    render={(pr) => (
                      <TextFieldCom
                        pr={pr}
                        id="memberDrawNum"
                        errors={errors}
                        label=""
                        queryType={queryType}
                        isPositiveNumber={true}
                        isNumber={true}
                        isParseInt={true}
                        setValue={setValue}
                      />
                    )}
                    control={control}
                    name="memberDrawNum"
                    rules={{
                      validate: () => {
                        if (
                          getValues('isShareMember') &&
                          (getValues('memberDrawNum') <= 0 ||
                            !getValues('memberDrawNum'))
                        ) {
                          return false;
                        }
                        return true;
                      },
                    }}
                  />
                </Box>
                <Box ml={0.5} fontSize="14px" fontWeight="400" color="#404041">
                  次
                </Box>
              </Box>
            </Box>
            <TitleML title="其他设定" fontSize="19px" p="32px 0" />
            <Box>
              <Box
                sx={{
                  fontSize: 12,
                  color: '#212100',
                  marginBottom: '8px',
                }}
              >
                活动及兑换说明
              </Box>
              <Controller
                render={(pr) => (
                  <TextFieldCom
                    pr={pr}
                    id="content"
                    errors={errors}
                    placeholder="请输入活动及兑换说明"
                    label=""
                    queryType={queryType}
                    setValue={setValue}
                  />
                )}
                control={control}
                name="content"
              />
            </Box>
            <Box>
              <Box
                sx={{
                  fontSize: 12,
                  color: '#212100',
                  marginBottom: '8px',
                }}
              >
                客服电话
              </Box>
              <Controller
                render={(pr) => (
                  <TextFieldCom
                    pr={pr}
                    id="phone"
                    errors={errors}
                    placeholder="请输入客服电话"
                    label=""
                    queryType={queryType}
                    setValue={setValue}
                  />
                )}
                control={control}
                name="phone"
              />
            </Box>
            <Box>
              <Box mb={2} color="#212100" fontSize="12px">
                奖品文字设置
              </Box>
              <Box className="set-color-font-wrap">
                <Box display="flex" gap="0 42px" alignItems="center">
                  <Box display="flex" gap="0 14px">
                    <Box display="flex">
                      <label
                        style={{
                          width: '39px',
                          lineHeight: '24px',
                          height: '24px',
                          color: 'rgba(0, 0, 0, 0.87)',
                        }}
                      >
                        字号
                      </label>
                      <FormControl variant="standard" sx={{ width: '70px' }}>
                        <Controller
                          render={(pr) => (
                            <SelectFieldCom
                              pr={pr}
                              typeList={fontSizeList}
                              queryType={queryType}
                            />
                          )}
                          label=""
                          name="prizeFontSize"
                          variant="standard"
                          control={control}
                        />
                      </FormControl>
                    </Box>
                    <Box display="flex">
                      <label
                        style={{
                          width: '39px',
                          lineHeight: '24px',
                          height: '24px',
                          color: 'rgba(0, 0, 0, 0.87)',
                        }}
                      >
                        颜色
                      </label>
                      <Box
                        sx={{
                          width: '100px',
                          display: 'flex',
                          justifyContent: 'space-between',
                          borderBottom: '1px solid rgba(0, 0, 0, 0.42)',
                        }}
                      >
                        <Typography
                          sx={{
                            color: getValues('prizeFontColor'),
                            lineHeight: '24px',
                            height: '24px',
                          }}
                        >
                          演示
                        </Typography>
                        <span
                          className="color-range"
                          onClick={() => {
                            queryType !== 'detail' && setOpenColorModal(true);
                            queryType !== 'detail' &&
                              setInputName('prizeFontColor');
                          }}
                          style={{ lineHeight: '24px', height: '24px' }}
                        >
                          <span
                            className="circle"
                            style={{
                              borderColor: getValues('prizeFontColor'),
                            }}
                          >
                            <ColorLensIcon
                              style={{ color: getValues('prizeFontColor') }}
                            />
                          </span>
                        </span>
                      </Box>
                      <Controller
                        render={(pr) => (
                          <TextField
                            sx={{ display: 'none' }}
                            variant="standard"
                            id="outlined-multiline-static"
                            autoComplete="off"
                            label=""
                            value={pr.value ?? ''}
                            error={Boolean(errors.file1)}
                          />
                        )}
                        control={control}
                        name="prizeFontColor"
                      />
                    </Box>
                  </Box>
                  {queryType !== 'detail' && (
                    <Box
                      sx={{
                        fontWeight: 400,
                        fontSize: 16,
                        color: '#1565C0',
                        width: '86px',
                        textAlign: 'center',
                        cursor: 'pointer',
                      }}
                      onClick={() =>
                        resetStyle('prizeFontSize', 'prizeFontColor')
                      }
                    >
                      恢复默认
                    </Box>
                  )}
                </Box>
              </Box>
            </Box>
            <Controller
              render={(pr) => (
                <TextField
                  sx={{ display: 'none' }}
                  variant="standard"
                  id="outlined-multiline-static"
                  autoComplete="off"
                  label=""
                  value={pr.value ?? ''}
                  error={Boolean(errors.file1)}
                />
              )}
              control={control}
              name="prizesList"
              rules={{
                validate: () => {
                  if (
                    getValues('prizesList').length === 0 ||
                    !getValues('prizesList') ||
                    chooseResetPrize(getValues('prizesList')) === 0 ||
                    chooseResetPrize(getValues('prizesList')) === 2
                  ) {
                    return false;
                  }
                  return true;
                },
              }}
            />
            <Button type="submit" ref={submitRef} style={{ display: 'none' }} />
          </form>
          <ModalML
            open={openColorModal}
            setOpen={setOpenColorModal}
            onClose={() => {
              setOpenColorModal(false);
            }}
            title={'选择颜色'}
          >
            <ModalStyled type={'colorSelect'}>
              <Box>
                <SketchPicker
                  color={color}
                  onChange={
                    (e) => {
                      setColor(e.hex);
                    }
                    // handleColorChange
                  }
                />
              </Box>
              <Box className="button-group" mt={3}>
                <Button
                  variant="contained"
                  color="secondary"
                  className="cancel"
                  startIcon={
                    <CloseIcon sx={{ width: '16px', height: '16px' }} />
                  }
                  onClick={() => {
                    setOpenColorModal(false);
                  }}
                >
                  取消
                </Button>

                <Button
                  variant="contained"
                  type="submit"
                  className="search"
                  onClick={() => {
                    setValue(inputName, color);
                    setOpenColorModal(false);
                  }}
                  startIcon={
                    <DoneIcon sx={{ width: '16px', height: '16px' }} />
                  }
                >
                  确 认
                </Button>
              </Box>
            </ModalStyled>
          </ModalML>
        </Box>
      </StepsTwoMLStyled>
    );
  },
);
